import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './AdministrativeSystemUploadFile.css';

const ADMIN_SYSTEM_ROOT =
  process.env.REACT_APP_ADMIN_SYSTEM_START_PATH ||
  process.env.REACT_APP_ADMIN_SYSTEM_BASE ||
  '/administrative-system';

function AdministrativeSystemUploadFile({
  currentPath,
  userId,
  onFileUploaded,
}) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={ADMIN_SYSTEM_ROOT}
      sessionPrefix="administrative_system_file"
    />
  );
}

AdministrativeSystemUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default AdministrativeSystemUploadFile;
